// extracted by mini-css-extract-plugin
export default {"container":"kr-z","heading":"lr-z","text":"mr-z","info":"nr-z","link":"or-z","fullMaxWidth":"pr-z"};